import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", {
  fill: "none",
  "fill-rule": "evenodd",
  stroke: "currentColor",
  "stroke-linejoin": "round",
  "stroke-width": "1.5"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    d: "M16.632 7.13V5.183c0-.654-.53-1.184-1.185-1.184H5.184C4.53 4 4 4.53 4 5.184v10.263c0 .654.53 1.185 1.184 1.185h1.967"
  }),
  /*#__PURE__*/_createElementVNode("path", { d: "M8.553 7.368h10.263c.654 0 1.184.53 1.184 1.185v10.263C20 19.47 19.47 20 18.816 20H8.553c-.654 0-1.185-.53-1.185-1.184V8.553c0-.654.53-1.185 1.185-1.185Z" })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }